import React from 'react';

const ImportMembersModal = ({ isOpen, onClose, onImportOption }) => {
  if (!isOpen) return null;

  const handleOptionClick = (option) => {
    onImportOption(option);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Import Members</h2>
          <button 
            className="text-gray-400 hover:text-gray-600 text-3xl font-light leading-none transition-colors"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        
        <div className="p-6">
          <p className="text-gray-600 mb-6">Add multiple members at once</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div 
              className="border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-indigo-500 hover:shadow-lg transition-all group"
              onClick={() => handleOptionClick('paste')}
            >
              <div className="text-4xl mb-3">📋</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">Copy & Paste</h3>
              <p className="text-sm text-gray-600">Paste your member list directly</p>
            </div>

            <div 
              className="border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-indigo-500 hover:shadow-lg transition-all group"
              onClick={() => handleOptionClick('upload')}
            >
              <div className="text-4xl mb-3">📁</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">Upload File</h3>
              <p className="text-sm text-gray-600">Import from CSV, Excel, or vCard</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportMembersModal;